<template>
  <hero-section />
  <about />
  <top-categories />
  <how-does-it-work />
  <benefits />
  <hot-deals />
  <brands v-if="partnerLogos" :partner-logos="partnerLogos"/>
</template>

<script>
import HeroSection from "@/client/applications/justopp/components/home/HeroSection.vue";
import About from "@/client/applications/justopp/components/home/About.vue";
import TopCategories from "@/client/applications/justopp/components/home/TopCategories.vue";
import HowDoesItWork from "@/client/applications/justopp/components/home/HowDoesItWork.vue";
import Benefits from "@/client/applications/justopp/components/home/Benefits.vue";
import HotDeals from "@/client/applications/justopp/components/home/HotDeals.vue";
import Brands from "@/client/applications/justopp/components/home/Brands.vue";
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";

export default {
  components: {
    HeroSection,
    About,
    TopCategories,
    HowDoesItWork,
    Benefits,
    HotDeals,
    Brands,
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus};
  },
  layout: "plain",
  meta: "justopp.defaultPage.mainTitle",
  data() {
    return {
      homepageData: false,
      asyncData: {
        homepageData: {
          target: "entity/homepage",
          data: {
            pagination: {
              start: 0,
              limit: 1,
            },
          },
          options: {
            dataMutator: (input) => {
              if (input.items && input.items[0]) {
                return input.items[0];
              }
              return false;
            },
            errorHandler: (err) => {},
          }
        }
      }
    }
  },
  computed: {
    partnerLogos() {
      if ( ! this.homepageData) {
        return false;
      }

      return [
        ...this.homepageData.partnerLogos,
        ...this.homepageData.partnerLogos,
      ]
    }
  }
};
</script>

<style lang="scss" scoped></style>
